import React, { useState, useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { Icon, Text } from '../../../../../components';

const ChildQuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 6px;
`;

const ChildQuestionsToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const AnimatedIcon = styled(Icon)`
  transition: transform 200ms linear;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(-90deg)')};
`;

const TransitionContainer = styled.div`
  display: flex;
  flex-direction: column;

  transition: max-height 200ms linear;
  overflow: hidden;
  max-height: ${({ $state, $height }) =>
    $state === 'entered' || $state === 'entering' ? `${$height}px` : 0};
`;

const ChildQuestionsToggle = ({ children = null, questionActions = null }) => {
  const [isToggleOpen, setToggleOpen] = useState(false);
  const toggleContentRef = useRef(null);
  const [toggleHeight, setToggleHeight] = useState(1000);

  useLayoutEffect(() => {
    if (toggleContentRef.current) {
      setToggleHeight(toggleContentRef.current.scrollHeight);
    }
  }, [isToggleOpen]);

  return (
    <ChildQuestionsContainer>
      <ChildQuestionsToggleContainer onClick={() => setToggleOpen(!isToggleOpen)}>
        <Text
          role='button'
          $bold
          $color='var(--action-tertiary-default)'
          onClick={() => setToggleOpen(!isToggleOpen)}
        >
          {isToggleOpen ? 'Hide plan steps' : 'Show plan steps'}
        </Text>
        <AnimatedIcon
          name='chevron-down'
          color='var(--action-tertiary-default)'
          size={16}
          onClick={() => setToggleOpen(!isToggleOpen)}
          isOpen={isToggleOpen}
        />
        {questionActions}
      </ChildQuestionsToggleContainer>
      <Transition in={isToggleOpen} timeout={200}>
        {(state) => (
          <TransitionContainer ref={toggleContentRef} $state={state} $height={toggleHeight}>
            {children}
          </TransitionContainer>
        )}
      </Transition>
    </ChildQuestionsContainer>
  );
};

ChildQuestionsToggle.propTypes = {
  children: PropTypes.node,
  questionActions: PropTypes.node
};

export { ChildQuestionsToggle };
